import {cProductItemAmounts}              from './amounts/product-item-amounts';
import { cProductItemComment }            from './comment/product-item-comment';
import { cProductItemDeliveryDate }       from './delivery-date/product-item-delivery-date';
import { cProductItemDeliveryInfo }       from './delivery-info/product-item-delivery-info';
import { cProductItemSecondaryPackaging } from './secondary-packaging/product-item-secondary-packaging';
import { cProductItemMarinades }          from './marinade/product-item-marinades';

export class cProductItem implements DateFieldTop {

  input_json = document.createElement('input');
  
  inputData          : SingleProduct;
  amounts            : cProductItemAmounts;
  deliveryInfo       : cProductItemDeliveryInfo;
  deliveryDate       : cProductItemDeliveryDate;
  secondaryPackaging : cProductItemSecondaryPackaging;
  marinades          : cProductItemMarinades;
  comment            : cProductItemComment;
  parentObj          : OrderItemContainer | DateFieldTop;

  constructor(
    inputData : SingleProduct, 
    parentElm : HTMLElement, 
    parentObj : OrderItemContainer | DateFieldTop,
    context   : 'single-product' | 'order-list' | 'cart',
  ) {

    this.inputData = inputData;
    this.parentObj = parentObj;

    // ---- Structure ---
    this.amounts            = new cProductItemAmounts           (inputData.item, inputData.product, parentElm, this, context);
    this.deliveryDate       = new cProductItemDeliveryDate      (inputData.item, inputData.product, parentElm, this);
    this.deliveryInfo       = new cProductItemDeliveryInfo      (                inputData.product, parentElm);
    this.secondaryPackaging = new cProductItemSecondaryPackaging(inputData.item,                    parentElm);
    this.marinades          = new cProductItemMarinades         (inputData.item, inputData.product, parentElm, this);
    this.comment            = new cProductItemComment           (inputData.item,                    parentElm);
      
    parentElm.append(this.input_json);

    // ---- Other ----    
    this.input_json.name  = 'c-json-product-item';
    this.input_json.value = JSON.stringify(this.getData());
    this.input_json.type  = 'hidden';

  }

  validateItem(silent: 'silent'|'', message: 'list'|'', isSelected?: boolean): boolean {

    const deliveryDate = this.deliveryDate.getDate();

    const isValid1 = this.amounts.validateItem(silent, deliveryDate, isSelected);
    const isValid2 = this.deliveryDate.validateItem(silent, message, isSelected);
    const isValid3 = this.marinades.validateItem(silent, isSelected);

    const isValid = 
      isValid1 && isValid2 && isValid3;
      
    return isValid;
  }

  changeEvent(eventSource: string): void {
    this.parentObj.changeEvent(eventSource);
  }

  isEmpty(): boolean {
    return this.amounts.isEmpty();
  }

  getData(): OrderListItem {
    const amounts            = this.amounts           .getData();
    const secondaryPackaging = this.secondaryPackaging.getData();
    const marinade           = this.marinades         .getData();
    const comment            = this.comment           .getData();
    const deliveryDate       = this.deliveryDate      .getDate();

    const output: OrderListItem = {
      customer_id         : this.inputData.item.customer_id,
      list_id             : this.inputData.item.list_id,
      item_id             : this.inputData.item.item_id,
      sku                 : this.inputData.item.sku,
      product_id          : this.inputData.item.product_id,
      selling_unit        : amounts.selling_unit,
      amount              : amounts.amount,
      amount_select       : amounts.amount_select,
      weight_per_piece    : amounts.weight_per_piece,
      secondary_packaging : secondaryPackaging,
      marinade            : marinade,
      components          : amounts.components,
      arranged            : amounts.arranged,
      comment             : comment,
      delivery_date       : deliveryDate,
      created             : this.inputData.item.created,
    }
    return output;
  }

  dataToInputElm() {
    this.input_json.value = JSON.stringify(this.getData());
  }
}